import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";
import AppMediumType from "@/models/Settings/AppMediums/AppMediumType";

export default class CreateAppMediumRequest {
    name: string = '';
    state: AppMediumState = AppMediumState.Enabled;
    accessTokenLifetime: number = 0;
    refreshTokenLifetime: number = 0;
    csr: string = '';
    whitelist: string[] = [];
    type: AppMediumType = AppMediumType.FiApiServiceAccount;
}